import React, { useState, useReducer, useRef, useEffect } from "react";

import FormButton from "../../Button/FormButton/FormButton";

import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import classes from './Login.module.css';

import { LoginHandler } from "../../../../store/auth-actions";
import FormCard from "./FormCard/FormCard";
import Input1 from "../../Inputs/Input1";
import mixpanel from "mixpanel-browser";


const emailReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.includes('@') };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: state.value.includes('@') };
    }
    //otherwise 
    return { value: '', isValid: false };
}

const passwordReducer = (state, action) => {
    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.trim().length >= 4 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.trim().length >= 4 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: state.value.trim().length >= 4 };
    }
    return { value: '', isValid: false };
};


const Login = (props) => {
    const [formIsValid, setFormIsValid] = useState(false);


    const [emailState, dispatchEmail] = useReducer(emailReducer, {
        value: '',
        isValid: null
    });



    const [passwordState, dispatchPassword] = useReducer(passwordReducer, {
        value: '',
        isValid: null
    });


    const emailInputRef = useRef()
    const passwordInputRef = useRef();


    const { isValid: emailIsValid } = emailState;
    const { isValid: passwordIsValid } = passwordState;

    useEffect(() => {
        const identifier = setTimeout(() => {
            // console.log('Checking form validity!');
            setFormIsValid(emailIsValid && passwordIsValid)

        }, 500);

        return () => {
            // console.log('CLEANUP');
            clearTimeout(identifier);
        };
    }, [emailIsValid, passwordIsValid,]);


    const emailChangeHandler = (event) => {
        dispatchEmail({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }

    const passwordChangeHandler = (event) => {
        dispatchPassword({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }

    const validateEmailHanlder = () => {
        dispatchEmail({ type: 'INPUT_BLUR' });
    }

    const validatePasswordHanlder = () => {
        dispatchPassword({ type: 'INPUT_BLUR' });
    }

    const onClearHandler = () => {
        dispatchEmail({ type: 'INPUT_CLEAR', val: "" })
        dispatchPassword({ type: 'INPUT_CLEAR', val: "" });
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const submitHandler = (event) => {
        event.preventDefault();

        if (formIsValid) {

            const Email = emailState.value;
            const Password = passwordState.value;

            mixpanel.track("Login attempted", {
                user: Email
            })

            dispatch(LoginHandler(Email, Password)).then((response) => {
                if (response && response.data && response.data.success) {
                    sessionStorage.setItem('pendingGroups', JSON.stringify(response.data.groups));
                    sessionStorage.setItem('pendingGetAllDevices', response.data.getAllDevices);

                    navigate("/Verify", {
                        state: {
                            token: response.data.msg.token,
                            client: response.data.userInfo.client,
                            refreshToken: response.data.msg.refreshToken,
                            email: Email,
                        }
                    });
                } else {
                    mixpanel.track("Login failed", {
                        user: Email
                    })
                }
            })
            return;
        } else if (!emailIsValid) {
            emailInputRef.current.focus();
        }
        else {
            passwordInputRef.current.focus();
        }
    };

    return (
        <FormCard>
            <h2 className={classes.Title}>{props.title || "Log In"}</h2>

             <p className={classes.subInfo}>
                Access to this portal is by invitation only. If you have not received an email to set up your account, please contact your account administrator or contact us directly{" "}
                <a href="mailto:support@inniovate.zohodesk.com?subject=Portal%20Access%20Request" className={classes.hyperLink}>here</a>

            </p>
 
            <form onSubmit={submitHandler} className={classes["container"]} >
                <ul className={classes["inputs-list"]}>
                    <li>
                        <Input1
                            placeholder="Email"
                            ref={emailInputRef}
                            id="email"
                            type={"email"}
                            isValid={emailState.isValid}
                            value={emailState.value}
                            onChange={emailChangeHandler}
                            onBlur={validateEmailHanlder}
                        />
                    </li>

                    <li>
                        <Input1
                            placeholder="Password"
                            ref={passwordInputRef}
                            id="password"
                            type={"password"}
                            isValid={passwordState.isValid}
                            value={passwordState.value}
                            onChange={passwordChangeHandler}
                            onBlur={validatePasswordHanlder}
                        />
                    </li>
                </ul>


                <FormButton value={props.buttonText || "Log In"} type="submit" />
                <h4 onClick={props.HandleShowModal} className={classes.serviceLink} >{props.serviceLink || "Forgotten Password?"}</h4>
            </form>

            <div>

            </div>
        </FormCard>
    );
}

export default Login;

